import React from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";

const PrivacyPolicy = () => {
  ChangeTitle("Privacy Policy");

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center heading">Privacy policy</h1>
            <h1 className="hanson text-center mb-[1%] heading">
              (Effective date April 2024)
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="">
            <h1 className="mb-[2rem] legal-title-y">Introduction:</h1>
            <p className="mb-[2rem] w-full legal-para">
              Welcome to GCC Law Help's digital ecosystem, which encompasses our
              website www.gcclawhelp.com, and associated mobile applications. We
              are dedicated to safeguarding your privacy. This Privacy Policy
              elucidates our practices regarding data collection, utilization,
              protection, and rights. By using our services, you consent to the
              practices described herein.
            </p>
            <ol className="pl-[1.5rem] lg:pl-[2.2rem] legal-ol-num-b">
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Comprehensive Data Collection:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Direct Inputs: Personal information such as names, contacts,
                    email addresses, and financial details for transactions is
                    collected directly from you.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    Automated Insights: Usage data, preferences, and feedback
                    are automatically gathered to enhance service quality.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    Children's Data: Our services are not directed to
                    individuals under 18; we do not knowingly collect data from
                    children.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Data Utilization:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    We may utilize your data to improve service quality,
                    communicate essential information, send agreed-upon
                    marketing materials, and maintain service security.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    Automated Decisions: We may use your data for profiling to
                    tailor our services to your needs better.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Data Sharing, Disclosure, and Minimization:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Data is shared with trusted third parties for service
                    improvement under strict confidentiality, disclosed when
                    legally required, and minimized to only what is necessary
                    for our purposes.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Data Security and Retention:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    We implement robust security measures and retain your data
                    only as long as necessary for the purposes outlined or as
                    required by law, after which it is deleted or anonymized.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                User Rights:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Users have rights to access, correct, delete, or port their
                    data and can object to or restrict its processing. Explicit
                    consent mechanisms are provided for significant data
                    processing activities.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Global Data Operations and Transfers:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Data may be transferred internationally, subject to legal
                    safeguards and protections.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Updates and User Engagement:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Changes to this policy will be communicated through our
                    platforms or directly to you.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Data Protection Officer and Contact Information:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    For inquiries or concerns regarding privacy, please contact
                    our Data Protection Officer at{" "}
                    <span className="legal-text-y">gcchelplaw@gmail.com</span>
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Breach Notification:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    In the event of a data breach, we are committed to notifying
                    affected individuals and relevant authorities in accordance
                    with legal requirements.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Third-party Links and Services:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Our platforms may contain links to third-party services. We
                    are not responsible for their privacy practices and
                    encourage you to review their policies.
                  </li>
                </ol>
              </li>
            </ol>
            <h1 className="mb-[2rem] legal-title-y2">Your Acknowledgment:</h1>
            <p className="mb-[2rem] w-full legal-para">
              By accessing and using our services, you acknowledge your
              understanding and agreement to collect, use, and share your
              information as this Privacy Policy outlines. Your privacy is our
              priority, and we are committed to protecting it by adhering to
              these practices and continuously improving our privacy measures.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
